import { useEffect, useRef, useState } from 'react'

/**
 * The show/hide menu both wide capacity sheets carry, one per axis.
 *
 * It is the only say over what the table shows: ticking something here must
 * always make it appear, so no second filter may run alongside it. What it
 * cannot override is emptiness -- see `crossFilter` in ./sheet -- which is
 * why each entry also reports its hours.
 */
export default function VisibilityMenu({ label, items, hidden, getKey, getLabel, getHint, onToggle,
                                 onShowAll, onHideAll, allLabel, noneLabel, emptyLabel }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [open])

  const hiddenCount = items.filter(it => hidden.has(getKey(it))).length

  return (
    <span ref={ref} className="relative inline-flex">
      <button type="button" onClick={() => setOpen(o => !o)}
        className={`px-3 py-1.5 text-xs rounded-lg border hover:bg-gray-50 ${
          hiddenCount > 0 ? 'border-gray-900 text-gray-900' : 'border-gray-200 text-gray-600'}`}>
        {label}
        {hiddenCount > 0 && ` (${items.length - hiddenCount}/${items.length})`}
      </button>
      {open && (
        <div className="absolute z-30 top-9 left-0 min-w-[15rem] max-h-72 overflow-auto bg-white border border-gray-200 rounded-lg shadow-lg py-1"
             onClick={e => e.stopPropagation()}>
          <div className="flex justify-between px-3 py-1.5 border-b border-gray-100">
            <button onClick={onShowAll} className="text-xs text-gray-600 hover:text-gray-900">
              {allLabel}
            </button>
            <button onClick={onHideAll} className="text-xs text-gray-600 hover:text-gray-900">
              {noneLabel}
            </button>
          </div>
          {items.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-400">{emptyLabel}</div>
          )}
          {items.map(it => {
            const key = getKey(it)
            const checked = !hidden.has(key)
            return (
              <label key={key}
                     className="flex items-center gap-2 px-3 py-1.5 text-xs hover:bg-gray-50 cursor-pointer">
                <input type="checkbox" checked={checked} onChange={() => onToggle(key)} />
                <span className="text-gray-700 truncate flex-1">{getLabel(it)}</span>
                {/* Its hours in the period, so it is obvious which entries are
                    empty -- an empty one stays out of the table even when
                    ticked here, because nothing would be in its row/column. */}
                {getHint && (
                  <span className="text-gray-400 tabular-nums shrink-0">{getHint(it)}</span>
                )}
              </label>
            )
          })}
        </div>
      )}
    </span>
  )
}
